import { categories } from "@/mocks/naruto";

interface Props {
  activeCategory: string;
  onSelect: (name: string) => void;
}

export default function CategorySection({ activeCategory, onSelect }: Props) {
  return (
    <section id="categories" className="mx-auto w-full max-w-7xl px-4 py-14 md:py-20">
      <div className="mb-10 flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
        <div>
          <p className="text-sm font-medium text-primary-600">CP 分类索引</p>
          <h2 className="mt-2 font-display text-3xl text-foreground-950 md:text-4xl">按CP找火影同人本子</h2>
          <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600">
            从鸣人CP到佐助CP，从鼬樱到卡卡西、鹿丸、我爱罗，热门角色向分类一应俱全。
            点击分类即可筛选对应作品，快速定位想看的故事。
          </p>
        </div>
        <a
          href="#hot"
          className="group flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 hover:text-primary-700"
        >
          查看全部作品
          <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
        </a>
      </div>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {categories.map((cat) => {
          const active = activeCategory === cat.name;
          return (
            <button
              key={cat.id}
              type="button"
              onClick={() => onSelect(cat.name)}
              className={`group relative overflow-hidden rounded-lg text-left transition-all hover:-translate-y-1 focus:outline-none focus:ring-2 focus:ring-primary-400 ${
                active ? "ring-2 ring-primary-500" : ""
              }`}
            >
              <div className="relative h-52 w-full overflow-hidden md:h-60">
                <img
                  src={cat.cover}
                  alt={`${cat.name} 火影同人本子分类封面`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent"></div>
                <span className="absolute right-3 top-3 rounded-full bg-background-50/20 px-3 py-1 text-xs text-background-50 ring-1 ring-background-50/30">
                  {cat.workCount}
                </span>
                <div className="absolute inset-x-0 bottom-0 p-4">
                  <h3 className="font-display text-2xl text-background-50">{cat.name}</h3>
                  <p className="mt-1 text-sm text-background-50/85">{cat.tagline}</p>
                </div>
              </div>
              <div className="bg-background-100 p-4">
                <p className="text-sm leading-relaxed text-foreground-700">{cat.desc}</p>
                <div className="mt-3 flex flex-wrap gap-2">
                  {cat.themes.map((t) => (
                    <span
                      key={t}
                      className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs text-secondary-900"
                    >
                      {t}
                    </span>
                  ))}
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </section>
  );
}